import { useMutation } from "@tanstack/react-query";
import { api } from "../utils/apiClient";

type CreateAirlineRequest = {
  airlineCode: string;
  airlineName: string;
  emailDomains: string[];
  isActive: boolean;
};

type CreateAirlineResponse = {
  code: string;
  name: string;
};

const createAirline = async (request: CreateAirlineRequest): Promise<CreateAirlineResponse> => {
  return api.post("/api/v1/airlines", { json: request }).json<CreateAirlineResponse>();
};

export const useCreateAirlineMutation = () => {
  return useMutation({
    mutationFn: createAirline,
  });
};
